<template>
  <v-dialog
    v-model="dialog"
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="success"
        dark
        v-on="on"
      >
        Create Kpi Category
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Kpi Category"
      text="Create Kpi Category"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
              />
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="type"
                v-validate="'required'"
                :error-messages="errors.collect('kpi_category_type_id')"
                :items="types"
                data-vv-name="kpi_category_type_id"
                data-vv-as="type"
                item-text="name"
                item-value="id"
                label="Type"
              />
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="metric"
                v-validate="'required'"
                :error-messages="errors.collect('metric_id')"
                :items="metrics"
                data-vv-name="metric_id"
                data-vv-as="metric"
                item-text="name"
                item-value="id"
                label="Metric"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :disabled="loading"
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],    
    data () {
      return {
        loading: false,
        progressing: false,
        dialog: false,

        name: null,
        type: null,      
        metric: null,

        types: [],
        metrics: [],
      }
    },
    computed: {
      isDataLoaded () {
        return this.metrics.length > 0 && this.types.length > 0
      },
    },
    watch: {
      dialog: function (dialog) {
        if (dialog && !this.isDataLoaded) {        
          this.loadData()
        } else {
          this.$validator.reset()
          this.$resetData()
        }
      },
    },
    methods: {
      loadData () {
        this.loading = true

        Promise.all([
          this.$api.kpiCategoryTypes().list(),
          this.$api.metrics().list(),
        ])
          .then(([types, metrics]) => {
            this.types = types.data
            this.metrics = metrics.data

            this.loading = false
          })

        this.resetForm()
      },
      submitForm () {
        this.validateForm().then((result) => {
          if (!result) return 

          this.setProgressing(true)

          this.$api.kpiCategories().create(this.prepareFormData())
            .then((res) => {
              if (res.status === 201) {
                this.$emit('created', res.data)       
                this.$snack({
                  message: 'Added new kpi category',
                })         

                this.setDialog(false)                
              }
            })
            .catch(() => {})
            .then(() => {
              this.setProgressing(false)
            })
        })
      },
      setProgressing (status) {
        this.progressing = status
      },
      setDialog (status) {
        this.dialog = status
      },
      resetForm () {
        this.name = ''
        this.type = ''
        this.metric = ''
        this.$validator.reset()
      },
      prepareFormData () {
        return {
          name: this.name,
          metric_id: this.metric,
          kpi_category_type_id: this.type,
        }
      },
      validateForm () {
        return this.$validator.validateAll()
      },  
    },
  }
</script>
